import React, {Component} from "react";
import {
    Card,
    CardBody,
    CardSubtitle,
    CardTitle
} from "reactstrap";
import defaultBookImage from "../assets/default-book-image.png";
import {Chip, Fab} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class SearchResult extends Component {

    render() {
        // Parent Variables
        let book = this.props.book || [];

        // Parent Functions
        const addToLibrary = this.props.addToLibrary;
        const openConfirmDialog = this.props.openConfirmDialog;
        const isInLibrary = this.props.isInLibrary;
        const isReading = this.props.isReading;
        const hasCompleted = this.props.hasCompleted;
        const openBookModal = this.props.openBookModal;

        const getTitle = (title) => {
            if (title.length > 40) {
                return title.substring(0, 40) + "...";
            }

            return title;
        }

        const getAuthors = (authors) => {
            if (authors) {
                return authors.join(", ");
            }
            return "Unknown";
        }

        const addOrRemove = (book, event) => {
            if (isInLibrary(book)) {
                openConfirmDialog(book);
            } else {
                addToLibrary(book);
            }
        }

        return (
            <Card className="book-card">

                <div className="book-status">
                    {(isInLibrary(book) && !isReading(book) && !hasCompleted(book)) &&
                        <Chip label={<FontAwesomeIcon icon="book"/>} className="unread-chip"/>
                    }

                    {isReading(book) &&
                        <Chip label={<FontAwesomeIcon icon="book-open"/>} className="reading-chip"/>
                    }

                    {hasCompleted(book) &&
                        <Chip label={<FontAwesomeIcon icon="check"/>} className="completed-chip"/>
                    }
                </div>

                <div className="card-image" onClick={() => openBookModal(book)}>
                    <object
                        data={`https://covers.openlibrary.org/b/ID/${book.cover_i}-M.jpg`}
                        type="image/jpg" width="100%" height="auto">
                        <img
                            src={defaultBookImage}
                            alt="Default book" width="100%" height="auto"/>
                    </object>
                    <div className="actions">
                        <Fab size="small" className={(isInLibrary(book)) ? "remove-button" : "add-button"}
                             onClick={(event) => addOrRemove(book, event)}>
                            <FontAwesomeIcon icon={(isInLibrary(book)) ? "times" : "plus"} className={(isInLibrary(book)) ? "remove" : "add"}/>
                        </Fab>
                    </div>
                </div>

                <CardBody className="book-card-body">
                    <CardTitle tag="h5">
                        {getTitle(book.title)}
                    </CardTitle>

                    <CardSubtitle className="mb-2 text-muted" tag="h6">
                        by {getAuthors(book.author_name)}
                    </CardSubtitle>
                </CardBody>

            </Card>
        );
    }
}

export default SearchResult;
